import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'z-layout',
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  constructor() {}
}
